export default {
  GetPerformanceDetails: 'GetPerformanceDetails',
  GetScreens: 'GetScreens',
  GetSeatList: 'GetSeatList',
  ReserveTempCartSeats: 'ReserveTempCartSeats',
};



// WEBPACK FOOTER //
// ./V7/syos/api/SyosServiceMethod.js